<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="handleSize" :height="handleSize" viewBox="0 0 20 20" fill="none">
    <path d="M10.75 9.25L16.9 3.1M17.5 6.1V2.5H13.9M9.25 2.5H7.75C4 2.5 2.5 4 2.5 7.75V12.25C2.5 16 4 17.5 7.75 17.5H12.25C16 17.5 17.5 16 17.5 12.25V10.75" :stroke="color" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({
  name: 'WcIconExternalLink',
  components: {
  },
  props: {
    size: {
      type: String,
      default: 'lg'
    }
  },
  computed: {
    handleSize() {
      switch (this.$props.size) {
        case 'lg': return 20
        case 'md': return 16
        case 'sm': return 14
        case 'xs': return 12
        default: return 20
      }
    }
  }
})
export default class extends Vue {
  @Prop({ default: '#5138ee' }) color!: string
}
</script>

<style scoped>
</style>
